var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cellphone",
    clipPath: "url(#clip0_123_10332)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.5 2.5C0.5 1.39688 1.39688 0.5 2.5 0.5H9.5C10.6031 0.5 11.5 1.39688 11.5 2.5V14.5C11.5 15.6031 10.6031 16.5 9.5 16.5H2.5C1.39688 16.5 0.5 15.6031 0.5 14.5V2.5ZM7 14.5C7 14.2348 6.89464 13.9804 6.70711 13.7929C6.51957 13.6054 6.26522 13.5 6 13.5C5.73478 13.5 5.48043 13.6054 5.29289 13.7929C5.10536 13.9804 5 14.2348 5 14.5C5 14.7652 5.10536 15.0196 5.29289 15.2071C5.48043 15.3946 5.73478 15.5 6 15.5C6.26522 15.5 6.51957 15.3946 6.70711 15.2071C6.89464 15.0196 7 14.7652 7 14.5ZM9.5 2.5H2.5V12.5H9.5V2.5Z",
    fill: "#727190"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_123_10332"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.0e240a8d6f9cb163ca54fa8c680a771a.svg";
export { ForwardRef as ReactComponent };